import { FC } from 'react';
import styled from 'styled-components';

const ContactUsButton: FC<any> = ({ data, handleClick }) =>
	data?.link?.includes('https') && !handleClick ? (
		<Link href={data?.link} target="_blank" rel="noopener noreferrer">
			{data?.text}
		</Link>
	) : (
		<Button type="button" onClick={handleClick}>
			{data?.text}
		</Button>
	);

const Link = styled.a`
	padding: 0 10px;
	margin-left: 30px;
	height: 46px;
	background-color: transparent;
	border: 2px solid var(--color-purple-alt);
	color: var(--color-purple-alt);
	font-family: var(--font-sans);
	box-sizing: content-box;
	border-radius: 14px;
	line-height: 46px;
	text-align: center;
	text-decoration: none;
	font-weight: var(--font-medium);
	cursor: pointer;
	transition: 0.3s;
	white-space: nowrap;

	&:hover {
		background-color: var(--color-purple-alt);
		color: var(--color-white);
	}

	@media (max-width: 1060px) {
		font-size: 14px;
		line-height: 42px;
		height: 42px;
		padding: 0 18px;
		margin-left: 17px;
	}
`;

const Button = styled.button`
	padding: 0 10px;
	margin-left: 30px;
	height: 46px;
	background-color: transparent;
	border: 2px solid var(--color-purple-alt);
	color: var(--color-purple-alt);
	font-family: var(--font-sans);
	box-sizing: content-box;
	border-radius: 14px;
	line-height: 46px;
	text-align: center;
	text-decoration: none;
	font-weight: var(--font-medium);
	cursor: pointer;
	transition: 0.3s;
	white-space: nowrap;

	&:hover {
		background-color: var(--color-purple-alt);
		color: var(--color-white);
	}

	@media (max-width: 1060px) {
		font-size: 14px;
		line-height: 42px;
		height: 42px;
		padding: 0 18px;
		margin-left: 17px;
	}
`;

export default ContactUsButton;
